<section class="synthesis-dashboard">
  @if (store.dashboardLoading() && !dashboard()) {
    <app-spinner></app-spinner>
  } @else if (store.dashboardFailed()) {
    <div class="state">
      <lib-no-data icon="cloud_off" size="small" message="synthesis.dashboard_failed"></lib-no-data>
      <lib-button color="secondary" icon="refresh" size="small" [text]="'companies.retry' | translate"
        (click)="store.reloadDashboard()"></lib-button>
    </div>
  } @else if (hasCharts()) {
    @for (key of panelKeys(); track key) {
      <app-dashboard-panel [dashboard]="$any(dashboard())" [scope]="scope()" [canEdit]="canEdit()"
        [refreshSignal]="store.refreshSignal" [excludeProjects]="store.excludedProjects"
        (companyDashboardChange)="store.setDashboard($event)"></app-dashboard-panel>
    }
  } @else {
    <div class="state">
      <lib-no-data icon="dashboard" size="small" message="synthesis.dashboard_empty"
        [description]="canEdit() ? 'synthesis.dashboard_empty_edit' : 'synthesis.dashboard_empty_desc'"></lib-no-data>

      @if (canEdit()) {
        <lib-button icon="add" [text]="'synthesis.add_widget' | translate" (click)="openEditor()"></lib-button>
      }
    </div>
  }
</section>
